<template>
  <div class="container">
    <hr />
    <center>
      <strong>@SUZUYA GROUP, &nbsp;{{ new Date().getFullYear() }}</strong>
    </center>
    <br />
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style></style>
